import jwt_decode from 'jwt-decode'

export function getInviteEmailFromToken(token: string): string | null {
  try {
    const decoded = jwt_decode(token) as { sub?: string }
    return decoded.sub ?? null
  } catch {
    return null
  }
}

export function getEmailFromGoogleCredential(credential: string): string | null {
  try {
    const decoded = jwt_decode(credential) as { email?: string }
    return decoded.email?.toLowerCase() ?? null
  } catch {
    return null
  }
}

export function omitInviteQueryParams(query: Record<string, unknown>): Record<string, string> {
  const result: Record<string, string> = {}
  for (const [key, value] of Object.entries(query)) {
    if (key === 'inviteToken' || key === 'inviteSessionCleared') {
      continue
    }
    if (typeof value === 'string') {
      result[key] = value
    }
  }
  return result
}
